<template>
    <div class="login-main">
		<div class="login-backgroud-main">
			<div class="login-panle">
				<div class="login-window">
					<div class="login-window-title">
						<image class="login-window-title-logo" src="../assets/uni.png"></image>
						<p class="login-window-title-p">{{title}}</p>
					</div>
					
					<!-- 帐号密码输入 -->
					<form class="el-form">
						<!-- 帐号 -->
						<div class="el-form-item">
							<div class="el-form-item__content">
								<div class="el-input el-input--suffix">
									<el-input @input="forceUpdate" type='text' v-model='phone_num' placeholder="请输入手机号">
										<i slot="suffix" class="el-input__icon el-icon-user"></i>
									</el-input>
								</div>
							</div>
						</div>
						
						<!-- 密码 -->
						<div class="el-form-item">
							<div class="el-form-item__content">
								<div class="el-input el-input--suffix">
									<el-input @input="forceUpdate" type='password' v-model='password' placeholder="请输入密码">
										<i slot="suffix" class="el-input__icon el-icon-lock"></i>
									</el-input>
								</div>
							</div>
						</div>
						
						<!-- 验证码 -->
						<div class="el-form-item is-error is-required" style="position: relative;">
							<div class="el-form-item__content">
								<div>
									<el-input style="width: 60%;" @input="forceUpdate" type='text' v-model='VerCode' placeholder="请输入验证码"></el-input>
									<!-- <image style="width: 33%; float:right!important; height: 38px" src="../../static/test/test_code.png"></image> -->
									
									<!-- <div style="" class="canvas-img-code" @click="refresh()"> -->
                                    <!-- <canvas class="canvas-img-code" @click="refresh()" style="width: 33%; float:right!important; height: 38px" canvas-id="imgcanvas" @error="canvasIdErrorCallback"></canvas> -->
									<!-- </div> -->
									<div class="code canvas-img-code" @click="refreshCode" style="width: 40%; float:right!important; height: 38px;">
										<s-identify :fresh="flag" @makedCode="getMakedCode"></s-identify>
									</div>
              					</div>			
							</div>
						</div>
						
						<!-- 登录按钮 -->
						<div>
							<!-- <el-button type="primary" style="width: 100%;" @click="goto('/pages/index/index')">{{login_btn}}</el-button> -->
							<el-button type="primary" style="width: 100%;" @click.native="LoginEvent()">{{login_btn}}</el-button>
						</div>

					</form>
				
				</div>
				
				<div class="login-panle-right"></div>
			</div>
		</div>

		<div class="footer">
            <div class="footer-content">
                <div class="footer-left">
                    <img class="company-logo" src="../assets/qingshe.png" alt="公司 Logo" />
                </div>
                <div class="divider"></div> <!-- 新增分割线 -->
                <div class="footer-right">
                    <p>公司地址: 陕西省西安市莲湖区高新一路正信大厦B1802室</p>
					<p>电话: 17782650736</p>
					<el-link style="font-size: 12px; margin-top: 10px;" href="https://beian.miit.gov.cn/">陕ICP备2022011206号-1</el-link>
					<p style="margin-top: 10px;">Copyright © 2022-2032 西安悦定科技有限公司 版权所有</p>
                </div>
            </div>
        </div>
	</div>
</template>

<script>
import SIdentify from '../components/identify.vue';

export default {
    name: 'codetest',
    components: {
        SIdentify
    },

    data() {
        
        return {
            title: "Light House Admin",
            phone_num: String(),
            password: String(),
            // 验证码
            VerCode: String(),
            login_btn: "登录",
            width: 120,
            height: 45,
            // 首页链接
            SIndexUrl: "/",
            flag: true, //该值变化，就会触发刷新
            code: '' //刷新后的验证码
        }
    },
    
    onShow() {
        _this = this;
        // // 刷新或首次进入刷新验证码
        // setTimeout(function() {
        // 	_this.init();
        // }, 100)
    },
     // 验证码初始化
    mounted() {
        this.flag = !this.flag;
    },

    // 自定义函数接口
    methods: {
        // 切换验证码
        refreshCode() {
            this.flag = !this.flag;
        },
        getMakedCode(code) {
            this.code = code;
            
            console.log('getMakedCode:', this.code);
        },

        forceUpdate(){
            this.$forceUpdate();
        },
		
		async getUserInfo(user_id) {
			let url = '/api/users/' + user_id + '/'
			console.log(url)
			let res = await this.$axios.get(url);
			console.log(res)
			window.sessionStorage.setItem("is_super_admin", res.data.is_super_admin);
		},
        
        // 登录按钮绑定事件
        LoginEvent(){
            
            // 判断是否输入账号
            if (this.phone_num.length === 0) {
                // console.log(111)
                this.$message({
                    showClose: true,
                    message: '您未输入账号',
                    type: 'error',
                    center: true,
                    offset: 50
                })
                return false
            }
            
            // 判断是否输入密码
            if (this.password.length === 0) {
                this.$message({
                    showClose: true,
                    message: '您未输入密码',
                    type: 'error',
                    center: true,
                    offset: 50
                })
                return false
            }
            
            // 判断验证码长度是否正确
            if (this.VerCode.length != 4) {
                this.$message({
                    showClose: true,
                    message: '验证码错误',
                    type: 'error',
                    center: true,
                    offset: 50
                })
				this.refreshCode();
                return false
            }
            
            // 判断验证码内容是否正确
            if (this.VerCode.toLowerCase() != this.code.toLowerCase()) {
                
                this.$message({
                    showClose: true,
                    message: '验证码错误',
                    type: 'error',
                    center: true,
                    offset: 50
                });
                // 如果验证码错误 重新刷新验证码
                
                this.refreshCode();
                return false
            }
            
			// 登录
			let _this = this;
			var url = '/api/web_login/'
			var d_data = {
				"phone_num": this.phone_num,
				"password": this.password,
			}
			this.$axios.post(
              url, d_data, {headers: {
				  "Content-Type": "application/json"
			  }}
            ).then(function(res){
				// this.goodsList = res.data;
				console.log(res.data)
				console.log('登录成功')
				// 存储token
				window.sessionStorage.setItem("token", res.data.token);
				// 存储当前用户名
				window.sessionStorage.setItem("username", res.data.username);
				// 存储当前用id
				window.sessionStorage.setItem("id", res.data.id);
				
				// 刷新tab标签
				_this.$store.commit('ref_opentab')
				// 跳转主页
				_this.$router.push('/');

				// 获取当前用户的基本信息
				_this.getUserInfo(res.data.id);

				console.log(window.sessionStorage)

				return true

			}).catch(function (error) {
				console.log(error);
				_this.$message({
					showClose: true,
					message: '帐号或密码错误',
					type: 'error',
					center: true,
					offset: 50
				});

				_this.refreshCode();
				return false
			});

            // console.log('登录成功')
            // this.$router.push('/');
        },
    }
}

</script>

<style>
	.login-main {
		height: 100vh;
	}
	
	.login-backgroud-main {
		background-image: url(../assets/login_background.jpg);
		background-size: cover;
		width: 100%;
		height: 100%;
		margin: 0;
		padding: 0;
		position: relative;
	}

	
	.login-panle {
		position: absolute;
		top: 3vh;
		left: 2vw;
		width: 96vw;
		height: 94vh;
		background-color: #fffc;
		backdrop-filter: blur(5px);
		border-radius: 10px;
		display: flex;
		align-items: center;
		justify-content: space-evenly;
	}
	
	.login-window {
		width: 420px;
		background-color: #fff;
		padding: 40px;
		border-radius: 10px;
		box-shadow: 2px 3px 7px #0003;
	}
	
	.login-window-title {
		display: flex;
		align-items: center;
		margin: 30px 0;
	}
	
	.login-window-title-logo {
		width: 70px;
		height: 70px;
	}
	
	.login-window-title-p {
		font-size: 35px;
		padding-left: 20px;
	}
	
	.login-panle-right {
		background-image: url(../assets/download.svg);
		background-size: cover;
		width: 40%;
		height: 60%;
		float: right!important;
	}
	
	.input-icon {
		padding-right: 6px;
		padding-top: 2px;
	}
	
	.el-icon {
		--color: inherit;
		height: 1em;
		width: 1em;
		line-height: 1em;
		text-align: center;
		display: inline-block;
		position: relative;
		fill: currentColor;
		color: var(--color);
		font-size: inherit;
	}
	.footer {
        background-color: #f5f5f5;
        padding: 20px 0;
    }

    .footer-content {
        display: flex;
        justify-content: center;
        align-items: flex-start;
        max-width: 1200px;
        margin: 0 auto;
        position: relative; /* 新增 position */
    }

    .divider {
        position: absolute; /* 新增 position */
        top: 0;
        bottom: 0;
        left: 50%; /* 将分割线定位在中间 */
        border-left: 1px solid #ccc;
    }

    .footer-left,
    .footer-right {
        flex: 1;
        padding: 0 20px;
    }

    .company-logo {
        width: 100px;
        height: auto;
    }

    .footer p {
        font-size: 12px;
        color: #333;
        line-height: 1.5;
        margin: 0;
        padding: 0;
    }

    .footer p + p {
        margin-top: 10px;
    }

	
</style>
